import {Link} from "react-router-dom";
import '../scss/error_pages.scss';

const NotFound = () =>{
    return (
        <div className="container">
            <div className="error_404">
                <img src='/wp-content/plugins/blog_tools/images/error404.svg' alt="Error 404"/>
                <h1>Страница не найдена</h1>
                <p>Запрашиваемая страница не найдена. Возможно, она была <br/>
                    перемещена, удалена или временно недоступна.</p>
                <Link className="round_green_button" to="/">Вернуться
                    на главную</Link>
            </div>
        </div>
    )
}

export default NotFound;